<app-side-menu>
  <div class="accounts-payable-view-content">
    <!-- Header -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header">
          <div class="d-flex align-items-center">
            <button 
              type="button"
              class="btn btn-outline-secondary me-3"
              (click)="goBack()">
              <i class="fas fa-arrow-left me-2"></i>
              Voltar
            </button>
            <div>
              <h1 class="page-title">
                <i class="fas fa-file-invoice-dollar me-3"></i>
                Visualizar Conta a Pagar
              </h1>
              <p class="page-subtitle">Detalhes completos da conta a pagar</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-container">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
      <p class="mt-3">Carregando dados da conta a pagar...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="alert alert-danger" role="alert">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>
        <button 
          type="button"
          class="btn btn-outline-danger btn-sm"
          (click)="loadAccountsPayable()">
          <i class="fas fa-redo me-1"></i>
          Tentar Novamente
        </button>
      </div>
    </div>

    <!-- Accounts Payable Details -->
    <div *ngIf="accountsPayable && !loading" class="row g-4">
      <!-- Informações do Documento -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-file-alt me-2"></i>
              Informações do Documento
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Número do Documento</label>
                  <div class="info-value document-number">{{ accountsPayable.documentNumber }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Tipo</label>
                  <div class="info-value">{{ accountsPayable.documentType }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Data de Emissão</label>
                  <div class="info-value">{{ formatDate(accountsPayable.issueDate) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Data de Vencimento</label>
                  <div class="info-value due-date" [class.overdue]="isOverdue()">
                    {{ formatDate(accountsPayable.dueDate) }}
                    <span *ngIf="isOverdue()" class="overdue-badge">
                      <i class="fas fa-exclamation-triangle"></i>
                      Vencido
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Nota Fiscal</label>
                  <div class="info-value">{{ accountsPayable.invoiceNumber || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Pedido de Compra</label>
                  <div class="info-value">{{ accountsPayable.purchaseOrderNumber || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-12">
                <div class="info-item">
                  <label class="form-label">Descrição</label>
                  <div class="info-value">{{ accountsPayable.description || 'N/A' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Valores e Status -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-calculator me-2"></i>
              Valores e Status
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Valor Original</label>
                  <div class="info-value amount">{{ formatCurrency(accountsPayable.originalAmount) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Status</label>
                  <div class="info-value">
                    <span class="status-badge" [ngClass]="getStatusClass(accountsPayable.status)">
                      {{ accountsPayable.status }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-md-6" *ngIf="accountsPayable.discountAmount">
                <div class="info-item">
                  <label class="form-label">Desconto</label>
                  <div class="info-value discount">{{ formatCurrency(accountsPayable.discountAmount) }}</div>
                </div>
              </div>
              <div class="col-md-6" *ngIf="accountsPayable.interestAmount">
                <div class="info-item">
                  <label class="form-label">Juros</label>
                  <div class="info-value interest">{{ formatCurrency(accountsPayable.interestAmount) }}</div>
                </div>
              </div>
              <div class="col-md-6" *ngIf="accountsPayable.fineAmount">
                <div class="info-item">
                  <label class="form-label">Multa</label>
                  <div class="info-value fine">{{ formatCurrency(accountsPayable.fineAmount) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Valor a Pagar</label>
                  <div class="info-value amount-primary">{{ formatCurrency(accountsPayable.amountToPay) }}</div>
                </div>
              </div>
              <div class="col-md-6" *ngIf="accountsPayable.amountPaid">
                <div class="info-item">
                  <label class="form-label">Valor Pago</label>
                  <div class="info-value amount-paid">{{ formatCurrency(accountsPayable.amountPaid) }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Valor Restante</label>
                  <div class="info-value amount-remaining">{{ formatCurrency(accountsPayable.remainingAmount) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Fornecedor e Classificação -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-building me-2"></i>
              Fornecedor e Classificação
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-12">
                <div class="info-item">
                  <label class="form-label">Fornecedor</label>
                  <div class="info-value supplier-name">{{ accountsPayable.supplierName || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Categoria</label>
                  <div class="info-value category">{{ accountsPayable.category }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Centro de Custo</label>
                  <div class="info-value">{{ accountsPayable.costCenterName || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-12" *ngIf="accountsPayable.totalInstallments">
                <div class="info-item">
                  <label class="form-label">Total de Parcelas</label>
                  <div class="info-value">{{ accountsPayable.totalInstallments }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Detalhes do Pagamento -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-credit-card me-2"></i>
              Detalhes do Pagamento
            </h5>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Forma de Pagamento</label>
                  <div class="info-value">{{ accountsPayable.paymentMethod || 'N/A' }}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="info-item">
                  <label class="form-label">Data de Pagamento</label>
                  <div class="info-value">{{ accountsPayable.paymentDate ? formatDate(accountsPayable.paymentDate) : 'N/A' }}</div>
                </div>
              </div>
              <div class="col-12" *ngIf="accountsPayable.paymentReference">
                <div class="info-item">
                  <label class="form-label">Referência do Pagamento</label>
                  <div class="info-value">{{ accountsPayable.paymentReference }}</div>
                </div>
              </div>
              <div class="col-md-6" *ngIf="accountsPayable.bankSlipNumber">
                <div class="info-item">
                  <label class="form-label">Número do Boleto</label>
                  <div class="info-value">{{ accountsPayable.bankSlipNumber }}</div>
                </div>
              </div>
              <div class="col-md-6" *ngIf="accountsPayable.checkNumber">
                <div class="info-item">
                  <label class="form-label">Número do Cheque</label>
                  <div class="info-value">{{ accountsPayable.checkNumber }}</div>
                </div>
              </div>
              <div class="col-12" *ngIf="accountsPayable.paidByStaffName">
                <div class="info-item">
                  <label class="form-label">Pago por</label>
                  <div class="info-value">{{ accountsPayable.paidByStaffName }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Comprovantes e Anexos -->
      <div class="col-lg-6">
        <div class="card h-100">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">
              <i class="fas fa-paperclip me-2"></i>
              Comprovantes e Anexos
            </h5>
            <div class="file-upload-wrapper d-flex flex-wrap align-items-center gap-2">
              <select
                class="form-select form-select-sm attachment-category-select"
                [(ngModel)]="selectedAttachmentCategory"
                [disabled]="uploadingFile"
                title="Tipo do documento">
                <option *ngFor="let opt of attachmentCategoryOptions" [ngValue]="opt.value">
                  {{ opt.label }}
                </option>
              </select>
              <input type="file" id="fileUpload" (change)="onFileSelected($event)" class="d-none" [disabled]="uploadingFile"
                accept=".pdf,.png,.jpg,.jpeg,.webp,.gif,.doc,.docx" />
              <label for="fileUpload" class="btn btn-sm btn-outline-primary mb-0" [class.disabled]="uploadingFile">
                <i class="fas" [class.fa-spinner]="uploadingFile" [class.fa-spin]="uploadingFile" [class.fa-upload]="!uploadingFile"></i>
                {{ uploadingFile ? 'Enviando...' : 'Anexar' }}
              </label>
            </div>
          </div>
          <div class="card-body">
            <div *ngIf="attachments.length === 0" class="text-muted text-center py-3">
              <i class="far fa-file-alt fa-2x mb-2 d-block"></i>
              Nenhum anexo encontrado.
            </div>
            <ul class="list-group list-group-flush" *ngIf="attachments.length > 0">
              <li class="list-group-item d-flex justify-content-between align-items-center" *ngFor="let file of attachments">
                <div class="text-truncate me-2">
                  <div [title]="getAttachmentDisplayName(file)">
                    <i class="far fa-file me-2 text-muted"></i>
                    <a
                      *ngIf="getAttachmentUrl(file); else attachmentNameOnly"
                      href="javascript:void(0)"
                      (click)="openAttachment(file)">
                      {{ getAttachmentDisplayName(file) }}
                    </a>
                    <ng-template #attachmentNameOnly>{{ getAttachmentDisplayName(file) }}</ng-template>
                  </div>
                  <small class="text-muted" *ngIf="file.category || file.uploadedBy">
                    {{ file.category || 'Anexo' }}
                    <span *ngIf="file.uploadedBy"> · {{ file.uploadedBy }}</span>
                  </small>
                </div>
                <div class="d-flex align-items-center gap-1 flex-shrink-0">
                  <button
                    type="button"
                    class="btn btn-sm btn-link"
                    (click)="openAttachment(file)"
                    [disabled]="!canDownloadAttachment(file)"
                    title="Abrir comprovante">
                    <i class="fas fa-external-link-alt"></i>
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-link"
                    (click)="downloadAttachment(file)"
                    [disabled]="!canDownloadAttachment(file) || isDownloadingAttachment(file)"
                    title="Baixar comprovante">
                    <i class="fas" [class.fa-download]="!isDownloadingAttachment(file)" [class.fa-spinner]="isDownloadingAttachment(file)" [class.fa-spin]="isDownloadingAttachment(file)"></i>
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- Ações -->
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fas fa-cogs me-2"></i>
              Ações
            </h5>
          </div>
          <div class="card-body">
            <div class="d-flex flex-wrap gap-3">
              <button 
                type="button" 
                class="btn btn-primary"
                (click)="editAccountsPayable()">
                <i class="fas fa-edit me-2"></i>
                Editar
              </button>
              
              <button 
                type="button" 
                class="btn btn-success"
                (click)="payAccountsPayable()"
                *ngIf="canPay()">
                <i class="fas fa-credit-card me-2"></i>
                Efetuar Pagamento
              </button>
              
              <button 
                type="button" 
                class="btn btn-warning"
                (click)="printAccountsPayable()">
                <i class="fas fa-print me-2"></i>
                Imprimir
              </button>
              
              <button 
                type="button" 
                class="btn btn-danger"
                (click)="deleteAccountsPayable()">
                <i class="fas fa-trash me-2"></i>
                Excluir
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Modal de Pagamento -->
    <div class="modal-backdrop show" *ngIf="showPaymentModal && canPay()"></div>
    <div class="modal d-block" *ngIf="showPaymentModal && canPay()" tabindex="-1" role="dialog" aria-modal="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fas fa-credit-card me-2"></i>
              Efetuar Pagamento
            </h5>
            <button type="button" class="btn-close" aria-label="Close" (click)="closePaymentModal()"></button>
          </div>
          <div class="modal-body">
            <div class="alert alert-danger mb-3" *ngIf="paymentModalError" role="alert">
              <i class="fas fa-exclamation-triangle me-2"></i>{{ paymentModalError }}
            </div>

            <div class="mb-3" *ngIf="accountsPayable?.costCenterId && (availableBalance !== null || loadingAvailableBalance)">
              <label class="form-label">Saldo disponível (centro de custo)</label>
              <div class="fw-semibold" *ngIf="loadingAvailableBalance">
                <span class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span> Carregando...
              </div>
              <div class="fw-semibold" *ngIf="!loadingAvailableBalance && availableBalance !== null">
                {{ formatCurrency(availableBalance) }}
              </div>
            </div>

            <div class="alert alert-warning mb-3" *ngIf="isPaymentAboveAvailableBalance()" role="alert">
              <i class="fas fa-exclamation-circle me-2"></i>
              Valor superior ao saldo disponível do centro de custo. O pagamento pode ser rejeitado pelo sistema.
            </div>

            <div class="mb-3">
              <label class="form-label">Valor a pagar neste lançamento</label>
              <div class="input-group">
                <span class="input-group-text">R$</span>
                <input
                  type="text"
                  class="form-control text-end fw-semibold"
                  [value]="formatMoneyBr(paymentAmount)"
                  (focus)="onPaymentAmountFocus($event)"
                  (input)="onPaymentAmountInput($event)"
                  inputmode="decimal"
                  autocomplete="off"
                  placeholder="0,00" />
              </div>
              <small class="text-muted d-block mt-1">
                Saldo em aberto: <strong>{{ formatCurrency(getRemainingPayableAmount(accountsPayable)) }}</strong>
              </small>
            </div>

            <div class="mb-3">
              <label class="form-label">Data de Pagamento</label>
              <input type="date" class="form-control" [(ngModel)]="paymentDate" />
            </div>

            <div class="mb-3">
              <label class="form-label">Forma de Pagamento</label>
              <select class="form-select" [(ngModel)]="paymentMethod">
                <option value="">Selecionar</option>
                <option *ngFor="let m of paymentMethodOptions" [value]="m">{{ m }}</option>
              </select>
            </div>

            <div class="mb-3">
              <label class="form-label">Referência</label>
              <input type="text" class="form-control" [(ngModel)]="paymentReference" placeholder="Ex: número da transação" />
            </div>

            <hr class="my-4" />

            <div class="payment-modal-attachments">
              <label class="form-label mb-2">
                <i class="fas fa-paperclip me-2"></i>
                Documentos do pagamento
              </label>
              <div class="d-flex flex-wrap align-items-end gap-2 mb-3">
                <div class="flex-grow-1" style="min-width: 200px;">
                  <label class="form-label small text-muted mb-1">Tipo do documento</label>
                  <select
                    class="form-select form-select-sm"
                    [(ngModel)]="paymentModalAttachmentCategory"
                    [disabled]="loading">
                    <option *ngFor="let opt of attachmentCategoryOptions" [ngValue]="opt.value">
                      {{ opt.label }}
                    </option>
                  </select>
                </div>
                <div>
                  <input
                    type="file"
                    id="paymentModalFileUpload"
                    (change)="onPaymentModalFileSelected($event)"
                    class="d-none"
                    multiple
                    accept=".pdf,.png,.jpg,.jpeg,.webp,.gif,.doc,.docx"
                    [disabled]="loading" />
                  <label for="paymentModalFileUpload" class="btn btn-sm btn-outline-primary mb-0" [class.disabled]="loading">
                    <i class="fas fa-upload me-1"></i>
                    Selecionar arquivo
                  </label>
                </div>
              </div>
              <p class="text-muted small mb-3">
                Escolha o tipo e selecione os arquivos. O envio ocorre ao confirmar o pagamento.
              </p>

              <div *ngIf="pendingReceiptFiles.length > 0" class="mb-3">
                <div class="small fw-semibold text-secondary mb-2">Aguardando envio</div>
                <ul class="list-group list-group-flush payment-attachment-list">
                  <li
                    class="list-group-item d-flex justify-content-between align-items-center py-2"
                    *ngFor="let item of pendingReceiptFiles; let i = index">
                    <span class="text-truncate me-2" [title]="item.file.name">
                      <i class="far fa-file me-2 text-primary"></i>{{ item.file.name }}
                      <small class="d-block text-muted">{{ item.category }}</small>
                    </span>
                    <button type="button" class="btn btn-sm btn-link text-danger p-0" (click)="removePendingReceipt(i)" title="Remover">
                      <i class="fas fa-times"></i>
                    </button>
                  </li>
                </ul>
              </div>

              <div *ngIf="attachments.length === 0 && pendingReceiptFiles.length === 0" class="text-muted small text-center py-2">
                Nenhum comprovante anexado ainda.
              </div>

              <ul
                class="list-group list-group-flush payment-attachment-list"
                *ngIf="attachments.length > 0">
                <li
                  class="list-group-item d-flex justify-content-between align-items-center py-2"
                  *ngFor="let file of attachments">
                  <span class="text-truncate me-2" [title]="getAttachmentDisplayName(file)">
                    <i class="far fa-file me-2 text-muted"></i>{{ getAttachmentDisplayName(file) }}
                    <small class="d-block text-muted" *ngIf="file.category">{{ file.category }}</small>
                  </span>
                  <div class="d-flex gap-1 flex-shrink-0">
                    <button
                      type="button"
                      class="btn btn-sm btn-link p-0"
                      (click)="openAttachment(file)"
                      [disabled]="!canDownloadAttachment(file)"
                      title="Abrir comprovante">
                      <i class="fas fa-external-link-alt"></i>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm btn-link p-0"
                      (click)="downloadAttachment(file)"
                      [disabled]="!canDownloadAttachment(file) || isDownloadingAttachment(file)"
                      title="Baixar comprovante">
                      <i class="fas" [class.fa-download]="!isDownloadingAttachment(file)" [class.fa-spinner]="isDownloadingAttachment(file)" [class.fa-spin]="isDownloadingAttachment(file)"></i>
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" (click)="closePaymentModal()" [disabled]="loading">Cancelar</button>
            <button
              type="button"
              class="btn btn-success"
              (click)="submitPayment()"
              [disabled]="loading || !paymentAmount || paymentAmount <= 0 || !paymentDate">
              <span *ngIf="loading" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
              Confirmar Pagamento
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-side-menu>
